module.exports = __webpack_public_path__ + "static/media/logo_sena_color.086f2ae9.png";